@if (tabs?.length) {
  <nav
    class="mb-2 flex w-min flex-nowrap items-center gap-3 border-b-2 border-french-blue-500"
    [ngClass]="[
      classOverrides,
      customStyle === 'insightsTabs' ? '!mb-0 !gap-0' : '',
    ]"
  >
    @for (tab of tabs; track tab) {
      <button
        class="ag1-tab"
        [ngClass]="[
          customStyle === 'insightsTabs'
            ? 'rounded-t-md border-x border-t border-french-blue-100 px-[6px] py-[2px] text-sm'
            : '',
          tab?.toLowerCase() === activeTab?.toLowerCase()
            ? 'ag1-tab--active'
            : '',
          tab?.toLowerCase() === activeTab?.toLowerCase() &&
          customStyle === 'insightsTabs'
            ? 'bg-french-blue-50'
            : '',
        ]"
        (click)="onTabChanges(tab)"
        [disabled]="loading || disabledTabs?.includes(tab)"
      >
        {{ tab | sentenceCase }}
      </button>
    }
  </nav>
}
